import React from 'react'
import {Award, Target, Users, TrendingUp} from 'lucide-react'

export default function About() {
  return (
    <div className="py-24 bg-gradient-to-b from-slate-900 to-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              About Triangle Project<br />
              <span className="bg-gradient-to-r from-cyan-400 to-emerald-400 bg-clip-text text-transparent">
                Consultants
              </span>
            </h2>
            
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              With over 20 years of experience, we've helped hundreds of organizations across various industries achieve their strategic goals through expert project consulting.
            </p>
            
            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              Our team of seasoned consultants brings diverse expertise and a proven track record of delivering results that drive business growth and operational excellence.
            </p>

            {/* Features */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="flex items-center space-x-3">
                <Award className="w-5 h-5 text-cyan-400 flex-shrink-0" />
                <span className="text-gray-300">Certified Experts</span>
              </div>
              <div className="flex items-center space-x-3">
                <Target className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                <span className="text-gray-300">Tailored Solutions</span>
              </div>
              <div className="flex items-center space-x-3">
                <Users className="w-5 h-5 text-amber-400 flex-shrink-0" />
                <span className="text-gray-300">Industry Knowledge</span>
              </div>
              <div className="flex items-center space-x-3">
                <TrendingUp className="w-5 h-5 text-purple-400 flex-shrink-0" />
                <span className="text-gray-300">Proven Results</span>
              </div>
            </div>

            {/* Certifications */}
            <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6">
              <h3 className="text-xl font-bold text-white mb-3">Certifications</h3>
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-cyan-400 rounded-full"></div>
                  <span className="text-gray-300">Historically Underutilized Business (HUB) Certified</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                  <span className="text-gray-300">NC Small Business Enterprise (NCSBE) Certified</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-amber-400 rounded-full"></div>
                  <span className="text-gray-300">Mobile & eNotary</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-purple-400 rounded-full"></div>
                  <span className="text-gray-300">Project Management (PMP)</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-cyan-400 rounded-full"></div>
                  <span className="text-gray-300">Six Sigma Black Belt</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Stats */}
          <div className="grid grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-cyan-500/10 to-cyan-500/5 border border-cyan-500/20 rounded-2xl p-8 text-center">
              <div className="text-5xl font-bold text-cyan-400 mb-2">20+</div>
              <div className="text-gray-300">Years of Excellence</div>
            </div>
            <div className="bg-gradient-to-br from-emerald-500/10 to-emerald-500/5 border border-emerald-500/20 rounded-2xl p-8 text-center">
              <div className="text-5xl font-bold text-emerald-400 mb-2">100+</div>
              <div className="text-gray-300">Projects Delivered</div>
            </div>
            <div className="bg-gradient-to-br from-amber-500/10 to-amber-500/5 border border-amber-500/20 rounded-2xl p-8 text-center">
              <div className="text-5xl font-bold text-amber-400 mb-2">98%</div>
              <div className="text-gray-300">Client Satisfaction</div>
            </div>
            <div className="bg-gradient-to-br from-purple-500/10 to-purple-500/5 border border-purple-500/20 rounded-2xl p-8 text-center">
              <div className="text-5xl font-bold text-purple-400 mb-2">50+</div>
              <div className="text-gray-300">Expert Consultants</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
